"use strict";



var main_home =  {

	
	setup : function(options) {

		const self = this

		const container = document.getElementById("slider")
		const spinner 	= document.getElementById("spinner")

		/*
		window.ready(function(){
			main_home.fix_body_height()
		})
		window.addEventListener("resize", main_home.fix_body_height, false)	*/

		// Activate show_hide_header
			this.show_hide_header()

		// Draw slider
			common.build_slider({
				container 	: container,
				ar_elements : options.ar_slider
			}).then(function(response){

				response.style.display = "block"
				
				// Activate slider
				$('.flexslider').flexslider({
					animation  		: "fade",  // fade / slide
					controlNav 		: false,
					directionNav 	: false,
					randomize 		: true,				
					rtl 			: true,
					animationSpeed 	: 1700
				});

				spinner.remove();
			})

		// load audio file
			
			window.onload = function(e){
				// play audio in background
				self.play_audio_in_background(options.audio_file)
			}			
			
		return true
	},//end setup



	/**
	* PLAY_AUDIO_IN_BACKGROUND__OLD
	* Use a trick to bypass autoplay restrictions in browsers
	* @see https://stackoverflow.com/questions/50490304/how-to-make-audio-autoplay-on-chrome
	*/
	play_audio_in_background__OLD : function(audio_file) {

		//var context = new AudioContext();
		var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)

		if (isChrome) {

			// iframe with silence file
				const silence_file = '../../assets/media/silence.mp3'
				const iframe = document.createElement("iframe")
					  iframe.setAttribute("allow","autoplay")
					  iframe.src = silence_file

			// audio element with real audio file
				const audio = document.createElement("audio")
					  audio.setAttribute("autoplay","autoplay")
					  audio.setAttribute("loop","loop")	  
					  audio.src = audio_file
		}
		
		return true
	},//end play_audio_in_background__OLD



	/**
	* PLAY_AUDIO_IN_BACKGROUND
	* Use a trick to bypass autoplay restrictions in browsers
	* @see https://stackoverflow.com/questions/50490304/how-to-make-audio-autoplay-on-chrome
	*/
	play_audio_in_background : function(audio_file) {

		// const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)

		// iframe with silence file
			const silence_file = '../../assets/media/silence.mp3'
			const iframe = document.createElement("iframe")
				  iframe.setAttribute("allow","autoplay")
				  iframe.src = silence_file
			

		// audio element with real audio file
			var audio_element = document.createElement("audio")
				audio_element.setAttribute("loop","loop")	
				audio_element.setAttribute("autoplay","autoplay")
				audio_element.src = audio_file

		// button sound
			const audio_button = document.createElement("i")
				  audio_button.id = 'audio_button'
				  audio_button.classList.add("fa", "fa-music")
				  audio_button.addEventListener("click",function(e){
				  		audio_element.paused ? audio_element.play() : audio_element.pause()
				  },false)

			const top_container = document.querySelector(".top_container")
				  top_container.appendChild(audio_button)
		
		return true
	},//end play_audio_in_background



	/**
	* SHOW_HIDE_HEADER
	* On window scroll, show / hide the header title
	*/
	show_hide_header : function() {

		const wrapper = document.getElementById("wrapper")

		//var $toTop  = $('.navbar-brand');
		var $toTop  	= $('#navbar,ul.links.root');
		//var $links_root = $('ul.links.root');
		
		$(wrapper).scroll(function () {

			if ($(this).scrollTop() > 190) {
				$toTop.fadeIn();
				//$links_root.show();
			} else if ($toTop.is(':visible')) {
				$toTop.fadeOut();
				//$links_root.hide();
			}
		});

		return true
	},//end show_hide_header



	/**
	* IR_CASO
	* Salta al caso desde el listado
	*/
	ir_caso : function(button_obj, event) {
		event.stopPropagation();

		window.location.href = "caso/" + button_obj.dataset.section_id

		return true
	},//end ir_caso



	/**
	* TOGGLE_ABSTRACT
	*/
	toggle_abstract : function(button, event) {
		
		if (IS_EXPO===false) {
			// show abstract layer
			event.stopPropagation();

			var display_style = 'flex' // block

			var current_overlay = button.querySelector('.image_overlay')
			if (current_overlay) {

				if (current_overlay.style.display==display_style) {
					// Unactive current
					current_overlay.style.display = 'none'
				}else{
					// Reset all
					this.unactive_all_image_overlay()	
					// Active current
					current_overlay.style.display = display_style
				}
			}
		}else{
			// go directly to record
			this.ir_caso(button, event)
		}
		

		return true
	},//end toggle_abstract



	/**
	* UNACTIVE_ALL_IMAGE_OVERLAY
	*/
	unactive_all_image_overlay : function() {
				
		const all_image_overlay = document.querySelectorAll('.image_overlay')
		const len = all_image_overlay.length		
		for (let i = len - 1; i >= 0; i--) {
			all_image_overlay[i].style.display = 'none'
		}

		return true
	}//end unactive_all_image_overlay



}//end main_home